import { useMemo } from 'react';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueExternalOption = props => {
  const {
    getFamilyValueResolver,
    operator,
    specialOptions,
    value
  } = props;
  const resolver = getFamilyValueResolver(operator);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
  const {
    reference
  } = useFetchResolver(resolver, value);
  const resolvedValue = useMemo(() => {
    if (specialOptions) {
      const specialValue = specialOptions.findLast(option => option.value === value);
      if (specialValue) {
        return specialValue.label || specialValue.value;
      }
    }
    if (reference) {
      return reference.label || reference.id;
    }
    return value;
  }, [reference, specialOptions, value]);
  return /*#__PURE__*/_jsx("span", {
    children: resolvedValue
  });
};
export default DisplayValueExternalOption;